
import { Component, Vue, Prop, Emit } from "vue-property-decorator";

@Component
export default class HiboButton extends Vue {
  @Prop({ type: String, default: null })
  protected text?: string;

  @Prop({ type: Boolean, default: false })
  protected secondary?: boolean;

  @Prop({ type: Boolean, default: false })
  protected tertiary?: boolean;

  @Prop({ type: String, default: null })
  protected icon?: string;

  @Prop({ type: Boolean, default: false })
  protected loading?: boolean;

  @Prop({ type: Boolean, default: false })
  protected small?: boolean;

  @Prop({ type: Boolean, default: false })
  protected disabled?: boolean;

  @Prop({ type: String, default: "button" })
  protected type?: string;

  @Prop({ type: Boolean, default: false })
  protected circle?: boolean;

  @Emit("click")
  clicked() {}

  handleClick() {
    if (!this.loading && !this.disabled) this.clicked();
  }
}
